import { ShieldCheck, Truck, RotateCcw, Scissors } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { CT_IMAGES } from "@/cleanteamData";

const qualityPoints = [
  { icon: Scissors, title: "Stitched, Not Printed", text: "Names and numbers are tackle-twill stitched — the same construction players wear." },
  { icon: ShieldCheck, title: "USA Inspected", text: "Every jersey passes a 4-point quality check before it ships." },
  { icon: Truck, title: "2-Day Dispatch", text: "Orders leave our warehouse within 2 business days, tracked door to door." },
  { icon: RotateCcw, title: "30-Day Returns", text: "Wrong size? Easy exchanges, no questions asked." },
];

export default function CleanTeamFooter() {
  return (
    <>
      <section id="quality" className="relative py-16 md:py-24 overflow-hidden" data-testid="quality-section">
        <img src={CT_IMAGES.fans} alt="Fans cheering in the stadium" className="absolute inset-0 w-full h-full object-cover opacity-20" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#07090E] via-[#07090E]/80 to-[#07090E]" />
        <div className="relative px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto">
          <Reveal>
            <p className="text-xs font-bold uppercase tracking-widest text-[#39FF14]">Built For Game Day</p>
            <h2 className="font-['Barlow_Condensed',sans-serif] text-4xl sm:text-5xl font-extrabold uppercase tracking-tight text-white mt-2" data-testid="quality-title">
              Quality You Can Feel
            </h2>
          </Reveal>
          <div className="mt-10 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {qualityPoints.map((q, i) => (
              <Reveal key={q.title} delay={i * 0.08} y={30}>
                <div className="rounded-2xl border border-white/10 bg-[#0F141F]/80 backdrop-blur-sm p-6 h-full hover:border-[#39FF14]/40 transition-colors duration-300" data-testid={`quality-card-${i}`}>
                  <q.icon size={24} className="text-[#39FF14]" />
                  <h3 className="font-['Barlow_Condensed',sans-serif] text-xl font-bold uppercase tracking-wide text-white mt-4">{q.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-white/55">{q.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <footer id="shipping" className="bg-[#07090E] border-t border-white/10" data-testid="ct-footer">
        <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto py-12 flex flex-col md:flex-row items-center justify-between gap-6">
          <span className="flex items-center gap-2.5">
            <span className="w-9 h-9 rounded-lg bg-[#39FF14] flex items-center justify-center font-['Barlow_Condensed',sans-serif] font-black text-[#07090E] text-lg leading-none">CT</span>
            <span className="font-['Barlow_Condensed',sans-serif] text-2xl font-extrabold uppercase tracking-wide text-white">Clean <span className="text-[#39FF14]">Team</span></span>
          </span>
          <p className="text-xs text-white/40 text-center">Fan-style jerseys · Not affiliated with the NFL or its teams · Secure checkout by Shopify</p>
          <p className="text-xs text-white/40">© 2026 Clean Team</p>
        </div>
      </footer>
    </>
  );
}
